import React, {useState} from 'react';
import AbstractModalView from 'common/components/AbstractModalView';
import styles from './styles.module.scss';
import api from "../../assets/api-24px.svg";
import {errors as E} from "../../../../common/constants/errors";
import ButtonTabuYashirServerRequest from "../ButtonTabuYashirServerRequest";

const ModalFormDataAndFileListView = ({
                                        data,
                                        onApprove,
                                        showGlobalErrorMessage,
                                      }) => {
  const [modalShown, setModalShown] = useState(false);

  return (
    <AbstractModalView
      subPath={`tabu-yashir-request`}
      modalClassName={modalShown ? styles.modalShown : styles.modalHidden}
      overlayClassName={modalShown ? styles.modalShown : styles.modalHidden}
      triggerContent={({openModal}) => (
        <div
          className={styles.buttonOpenModalAreYouSure}
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            const {gush, helka, ttHelka} = data;
            if (gush && helka && ttHelka) {
              openModal();
              setModalShown(true);
            } else {
              showGlobalErrorMessage(E.FILL_BLOCK_AND_PLOT);
            }
          }}
        >
          <img src={api} className={styles.buttonIcon} alt="apiRequestIcon"/>
          <div className={styles.buttonLabel}>הפק</div>
        </div>
      )}
      modalContent={({closeModal}) => (
        <div className={styles.modalContainer}>
          <h2 className={styles.modalMessage}>הפקת נסח טאבו כרוכה בחיוב</h2>
          <div className={styles.modalButtons}>
            <div
              className={styles.buttonCancel}
              onClick={() => {
                closeModal();
                setModalShown(false);
              }}
            >
              <span>ביטול</span>
            </div>
            <ButtonTabuYashirServerRequest
              data={data}
              onApprove={onApprove}
              closeAreYouSureModal={closeModal}
              setModalShown={setModalShown}
            />
          </div>
        </div>
      )}
    />
  )
};

export default ModalFormDataAndFileListView;
